<template>
  <div class="lg:px-0 md:px-0 px-4 relative">
    <img
      src="@/assets/images/line/Frame 1000002302.png"
      alt="lineimg"
      class="m-auto"
    />
    <TestimonialDetailsPopup
      :isActive="isDetailsActive"
      :selectedTesimonial="selectedTesimonial"
      @close="toggleDetails"
    />
    <div class="relative flex">
      <div class="absolute bg-designGT mob-hidden">
        <img src="../../../assets/images/bg-des/bgdTG.svg" alt="bg-polygon" />
      </div>
      <div class="absolute bg-design-dots-tsm mob-hidden">
        <img src="../../../assets/images/Ellipse 12.svg" alt="bg-polygon" />
      </div>
    </div>
    <div class="">
      <p
        class="title sm-fsize16 md:font-normal lg:font-normal font-bold lg:pb-8 md:pb-8 pb-4 lg:px-12 md:px-12"
      >
        Testimonials
      </p>
      <div class="example-3d" @mouseenter="mouseover" @mouseleave="mouseleave">
        <swiper class="swiper" :options="swiperOptions">
          <swiper-slide
            class="sm-h-auto cursor-pointer"
            v-for="(item, index) in testimonals"
            :key="index"
          >
            <div class="w-full p-8 cust-bg" @click="toggleDetails(true, item)">
              <div class="">
                <!-- <img :src="item.quotesImgopen" alt="quotesimg" class="w-4 h-4" /> -->
                <p
                  class="pt-2 clr777 font-normal fsize16px italic ellipsis-9 md-ellipsis-6"
                >
                  <span class="text-0193a1 fsize25"> ❝</span>
                  {{ item.text }}
                  <span class="text-0193a1 fsize25"> ❞</span>
                </p>
                <!-- <img :src="item.quotesImgclose" alt="quotesimg" class="w-4 h-4" /> -->
                <div class="mx-auto text-center">
                  <img
                    :src="item.userImg"
                    class="mt-6 rounded-full w-20 h-20 border-user mx-auto object-fill"
                    alt=""
                  />
                  <p class="pt-3 font-normal fsize14px text-black">
                    {{ item.name }}
                  </p>
                  <p class="text-sm pt-1 clr777 font-light">
                    {{ item.description }}
                  </p>
                </div>
              </div>
            </div>
          </swiper-slide>

          <div
            class="swiper-pagination cust-posi bott-10"
            slot="pagination"
          ></div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";

import TestimonialDetailsPopup from "./TestimonialDetailsPopup";
export default {
  components: {
    swiper,
    swiperSlide,
    TestimonialDetailsPopup,
  },
  data() {
    return {
      selectedTesimonial: {},
      testimonals: [
        {
          id: "01",
          quotesImgopen: require("../../../assets/images/comma.png"),
          text: "“We need to step back and evaluate our training, as we are not getting a holistic perspective. I think we need to educate both the community and doctors, so that we become a more compassionate lot. It has to be person-centric and not patient-centric care, with a focus on the art of healing. Look beyond the patient and also address the burden a caregiver is going through.” ",
          quotesImgclose: require("../../../assets/images/commaclose.png"),
          userImg: require("../../../assets/images/team/Rajam Iyer.jpeg"),
          name: "Dr.Rajam Iyer",
          description:
            "Pulmonologist, Palliative care physician & Active caregiver",
          html: `<p class="">“We need to step back and evaluate our training, as we are not getting a holistic perspective. I think we need to educate both the community and doctors, so that we become a more compassionate lot. It has to be person-centric and not patient-centric care, with a focus on the art of healing. Look beyond the patient and also address the burden a caregiver is going through.” </p>`,
        },
        {
          id: "02",
          quotesImgopen: require("../../../assets/images/comma.png"),
          text: "“Add life to days and not days to life. Death is the biggest barrier and people are afraid to talk about it candidly. I think we need to open up, be transparent and talk about our fears, resentments, guilt, sense of bereavement, including death in the discussion with our loved ones.” ",
          quotesImgclose: require("../../../assets/images/commaclose.png"),
          userImg: require("../../../assets/images/team/Dr. Roop.jpeg"),
          name: "Dr. Roop Gursahani",
          description: "Palliative care physician & Experienced caregiver",
          html: `<p class="">“Add life to days and not days to life. Death is the biggest barrier and people are afraid to talk about it candidly. I think we need to open up, be transparent and talk about our fears, resentments, guilt, sense of bereavement, including death in the discussion with our loved ones.” </p>`,
        },
      ],
      swiperOptions: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 2.2,
        spaceBetween: 170,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        roundLengths: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 3,
          slideShadows: true,
        },
        breakpoints: {
          1600: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          1300: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          505: {
            slidesPerView: 1,
            spaceBetween: 55,
          },
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
      isDetailsActive: false,
    };
  },

  computed: {
    async swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedTesimonial = item;
    },
    mouseover() {
      // console.log("sumit", this.swiper);
      // this.swiper.autoplay.pause();
    },
    mouseleave() {
      // console.log("sir ji");
      // this.swiper.autoplay.run();
    },
  },
};
</script>

<style lang="scss" scoped>
.example-3d {
  width: 100%;
}

.swiper {
  height: 100%;
  width: 100%;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 500px;
    height: 430px;
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    background-position: center;
    background-size: cover;
    color: white;
    border: 10px solid #e9ddfa;
    border-radius: 25px;
    background-color: white !important;
  }

  .swiper-pagination {
    .swiper-pagination-bullet.swiper-pagination-bullet-active {
      background-color: white;
    }
  }
}
.border-user {
  border: 4px solid #0193a1;
  border-radius: 100%;
}
// .cust-bullet > .swiper-pagination-bullet {
// }
.cust-bullet > .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #000;
  opacity: 0.2;
  margin-left: 3px !important;
  margin-right: 3px !important;
}
.cust-bg .swiper-container-3d .swiper-slide-shadow-right {
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    from(rgba(146, 146, 146, 0.2)),
    to(rgba(0, 0, 0, 0))
  ) !important ;
  background-image: -webkit-linear-gradient(
    left,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
  background-image: -o-linear-gradient(
    left,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
}
.cust-posi {
  position: initial !important;
  padding-top: 25px;
}
.testimonal-h650px {
  height: 650px;
}
.bott-10 {
  bottom: 10%;
}
</style>
